import { Link } from "react-router-dom";
import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section className="relative flex min-h-[92vh] items-center overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20composition%20with%20glowing%20lime%20green%20geometric%20shapes%2C%20floating%20mathematical%20formulas%20and%20smooth%20graph%20curves%2C%20deep%20charcoal%20background%2C%20soft%20volumetric%20light%2C%20minimal%20editorial%20poster%20art%2C%20high%20contrast%2C%20cinematic%20depth%2C%20no%20text&width=1920&height=1080&seq=mbhj-hero-main-01&orientation=landscape"
        alt="명불허전 수학학원 수학 학습 분위기 이미지"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-60"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/65 to-foreground-950" />
      <div className="pointer-events-none absolute inset-0 grain-light opacity-30" />

      <div className="relative z-10 mx-auto w-full max-w-content px-5 pb-16 pt-28 md:px-8 md:pb-24 md:pt-36">
        <div className="flex flex-col items-center gap-10 lg:flex-row lg:items-center lg:gap-14">
          {/* 텍스트 영역 */}
          <div className="w-full max-w-3xl lg:flex-1">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/5 px-4 py-2 font-label text-xs tracking-[0.18em] text-white/80 ring-1 ring-white/15">
              <span className="h-2 w-2 rounded-full bg-primary-500" />
              초·중·고 수학 전문 · 소수정예 1:6
            </span>

            <h1 className="mt-6 font-heading text-[2.6rem] font-black leading-[1.05] tracking-tight text-white md:text-7xl">
              이름값 하는 수학,
              <br />
              <span className="text-primary-500">성적으로</span> 증명합니다
            </h1>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 md:text-lg">
              18년간 수학만 가르쳐 온 전문성으로, 학생 한 명 한 명의 실력을
              끝까지 책임집니다. 입학테스트로 현재를 진단하고, 가장 맞는 길을
              안내해 드립니다.
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/consult"
                className="group relative inline-flex items-center justify-center gap-2 overflow-hidden whitespace-nowrap rounded-full bg-primary-500 px-7 py-4 text-sm font-bold text-foreground-950 transition-colors hover:bg-primary-400 cursor-pointer"
              >
                <span className="shine absolute inset-y-0 left-0 w-1/2 bg-white/50 blur-md" />
                <span className="relative z-10">상담신청 하기</span>
                <i className="ri-arrow-right-line relative z-10" />
              </Link>
              <Link
                to="/classes"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/25 px-7 py-4 text-sm font-bold text-white transition-colors hover:bg-white/10 cursor-pointer"
              >
                수업안내 보기
                <i className="ri-arrow-right-up-line" />
              </Link>
            </div>

            <dl className="mt-12 grid grid-cols-2 gap-x-6 gap-y-6 border-t border-white/10 pt-8 md:grid-cols-4">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-heading text-3xl font-black tracking-tight text-primary-500 md:text-4xl">
                    {stat.value}
                  </dt>
                  <dd className="mt-1 text-sm text-white/60">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* 원장 상반신 */}
          <div className="relative shrink-0 lg:order-2">
            <div className="relative h-[300px] w-[220px] sm:h-[380px] sm:w-[290px] lg:h-[520px] lg:w-[400px]">
              <img
                src="https://public.readdy.ai/ai/img_res/4c2d43ee-4b9c-44d5-8253-2210fe32747b.png"
                alt="명불허전 수학학원 김명헌 원장"
                title="명불허전 수학학원 김명헌 원장"
                className="h-full w-full object-cover object-top -scale-x-100"
              />
            </div>
            <div className="mt-5 flex items-center justify-center gap-3 lg:justify-start">
              <span className="hidden h-px w-8 bg-primary-500/70 sm:block" />
              <div className="text-center lg:text-left">
                <p className="font-heading text-sm font-bold text-white">
                  김명헌 원장
                </p>
                <p className="mt-0.5 font-label text-[11px] tracking-[0.14em] text-white/50">
                  수학 교육 18년 · 서울대 수학교육과
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 hidden -translate-x-1/2 md:block">
        <div className="flex h-9 w-5 justify-center rounded-full border border-white/30 pt-1.5">
          <span className="animate-scroll-dot h-2 w-1 rounded-full bg-white/50" />
        </div>
      </div>
    </section>
  );
}